import React, { useState } from 'react';
import { useAssetContext } from '../contexts/AssetContext';
import { fetchAllAssets } from '../utils/api';

const SyncButton = () => {
  const { state, dispatch } = useAssetContext();
  const [syncStatus, setSyncStatus] = useState('');

  const syncData = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    setSyncStatus('Starting sync...');
    
    try {
      const allAssets = await fetchAllAssets(state.exchanges);
      dispatch({ type: 'SET_ASSETS', payload: allAssets });
      setSyncStatus(`Sync complete! Found ${allAssets.length} assets.`);
      
      // Clear status after 3 seconds
      setTimeout(() => {
        setSyncStatus('');
      }, 3000);
    } catch (error) {
      console.error('Sync error:', error);
      setSyncStatus('Error during sync: ' + error.message);
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  };

  return (
    <div className="flex items-center space-x-4">
      <button
        onClick={syncData}
        disabled={state.loading}
        className={`px-4 py-2 rounded-md text-sm font-medium ${
          state.loading
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
        }`}
      >
        {state.loading ? 'Syncing...' : 'Sync Now'}
      </button>
      {syncStatus && (
        <div className="text-sm text-gray-600">
          {syncStatus}
        </div>
      )}
    </div>
  );
};

export default SyncButton;